import { observer } from "mobx-react-lite";

import "./BenefitsListHeader.scss";

import Button from "components/commons/Button/Button";
import AppStore from "stores/AppStore";
import React from "react";
import {useHistory} from "react-router-dom";

const BenefitsListHeader: React.FC = () => {
  const history = useHistory();
    const {
        i18n: {
            benefits: { create }
        }
    } = AppStore;


    return (
        <div className="c-benefits-list-header">
            <div className="c-benefits-list-header__right-items">
                <Button
                    className="c-benefits-list-header__new-button"
                    text={create}
                    onClick={() => {
                      history.push("/benefits/new");
                    }}
                />
            </div>
        </div>
    );
};

export default observer(BenefitsListHeader);
